// Portal link positions (portal_position ids). The booth form uses 0-2 (Left, Center, Right); a 3D ad's portal also has 3 (Back).
// Unity manages positions by id, so the ids are the contract and the names are only labels.
export const AD_PORTAL_POSITIONS = [
  { id: 0, name: 'Left' },
  { id: 1, name: 'Center' },
  { id: 2, name: 'Right' },
  { id: 3, name: 'Back' },
];

export const PORTAL_POSITION_NAMES = Object.freeze(
  Object.fromEntries(AD_PORTAL_POSITIONS.map((p) => [p.id, p.name])),
);

export const AD_PORTAL_POSITION_COUNT = AD_PORTAL_POSITIONS.length;

// "Left" for 0 ... "Back" for 3; falls back to "Position N" for an id this build does not know.
export const portalPositionLabel = (positionId) =>
  PORTAL_POSITION_NAMES[positionId] ?? `Position ${positionId}`;

// The order the four positions are SHOWN in the portal editor: Left, Right, Center, Back. It is ONLY a display order: every position keeps
// its own id (0 Left, 1 Center, 2 Right, 3 Back, the contract with Unity), and the editor state and the request are indexed by that id.
export const AD_PORTAL_POSITION_DISPLAY_ORDER = [0, 2, 1, 3];

export const AD_PORTAL_POSITIONS_IN_DISPLAY_ORDER = AD_PORTAL_POSITION_DISPLAY_ORDER.map((id) => AD_PORTAL_POSITIONS.find((p) => p.id === id));
